import React, { useState, useEffect } from "react";
import {
  Box, Card, CardContent, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Paper, Button, Modal, TextField, Typography
} from "@mui/material";

const CrudTable = ({ title, columns, fields, service, entityName, companyId, renderForm }) => {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    if (service.getAll) {
      service.getAll(companyId).then(setItems);
    }
  }, [companyId, service]);

  const handleOpenEdit = (item) => {
    setSelectedItem(item);
    setIsEditing(true);
    setOpen(true);
  };

  const handleOpenCreate = () => {
    const emptyObj = fields.reduce((acc, f) => ({ ...acc, [f.name]: "" }), {});
    setSelectedItem(emptyObj);
    setIsEditing(false);
    setOpen(true);
  };

  const handleClose = () => setOpen(false);

  const handleChange = (e) => {
    setSelectedItem({ ...selectedItem, [e.target.name]: e.target.value });
  };

  const handleSave = async () => {
    if (isEditing) {
      const updated = await service.update(companyId, selectedItem.id, selectedItem);
      setItems((prev) => prev.map((it) => (it.id === selectedItem.id ? updated : it)));
    } else {
      const created = await service.create(companyId, selectedItem);
      setItems((prev) => [...prev, created]);
    }
    handleClose();
  };

  const handleOpenDeleteConfirm = (item) => {
    setItemToDelete(item);
    setConfirmOpen(true);
  };
  const handleCloseDeleteConfirm = () => setConfirmOpen(false);
  const handleDelete = async () => {
    await service.remove(companyId, itemToDelete.id);
    setItems((prev) => prev.filter((it) => it.id !== itemToDelete.id));
    handleCloseDeleteConfirm();
  };

  return (
    <Box sx={{ display: "flex", justifyContent: "center", mt: 5 }}>
      <Card sx={{ width: "80%", maxWidth: 900, p: 2, boxShadow: 3 }}>
        <CardContent>
          <Typography variant="h5" align="center" gutterBottom>{title}</Typography>

          {service.create && (
            <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
              <Button variant="contained" onClick={handleOpenCreate}>+ Adicionar {entityName}</Button>
            </Box>
          )}

          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  {columns.map((col) => <TableCell key={col.key}>{col.label}</TableCell>)}
                  {(service.update || service.remove) && <TableCell>Ações</TableCell>}
                </TableRow>
              </TableHead>
              <TableBody>
                {items.map((item) => (
                  <TableRow key={item.id}>
                    {columns.map((col) => (
                      <TableCell key={col.key}>
                        {col.render ? col.render(item[col.key], item) : item[col.key]}
                      </TableCell>
                    ))}
                    {(service.update || service.remove) && (
                      <TableCell>
                        {service.update && <Button variant="outlined" sx={{ mr: 1 }} onClick={() => handleOpenEdit(item)}>Editar</Button>}
                        {service.remove && <Button variant="outlined" color="error" onClick={() => handleOpenDeleteConfirm(item)}>Excluir</Button>}
                      </TableCell>
                    )}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </CardContent>
      </Card>

      <Modal open={open} onClose={handleClose}>
        <Box sx={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", bgcolor: "background.paper", p: 3, width: 400, boxShadow: 24, borderRadius: 2 }}>
            <Typography variant="h6">{isEditing ? `Editar ${entityName}` : `Novo ${entityName}`}</Typography>

            {selectedItem && (
            renderForm 
                ? renderForm(selectedItem, handleChange, setSelectedItem) 
                : fields.map((f) => (
                    <TextField 
                    key={f.name} 
                    fullWidth 
                    margin="normal" 
                    type={f.type || "text"} 
                    label={f.label} 
                    name={f.name} 
                    value={selectedItem[f.name]} 
                    onChange={handleChange} 
                    />
                ))
            )}

            <Box sx={{ mt: 2, display: "flex", justifyContent: "flex-end", gap: 1 }}>
            <Button onClick={handleClose}>Cancelar</Button>
            <Button variant="contained" onClick={handleSave}>Salvar</Button>
            </Box>
        </Box>
        </Modal>

      <Modal open={confirmOpen} onClose={handleCloseDeleteConfirm}>
        <Box sx={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", bgcolor: "background.paper", p: 3, width: 350, boxShadow: 24, borderRadius: 2, textAlign: "center" }}>
          <Typography variant="h6">Confirmar Exclusão</Typography>
          <Typography sx={{ mt: 1 }}>Deseja excluir <strong>{itemToDelete?.name || entityName}</strong>?</Typography>
          <Box sx={{ mt: 3, display: "flex", justifyContent: "center", gap: 2 }}>
            <Button onClick={handleCloseDeleteConfirm}>Cancelar</Button>
            <Button variant="contained" color="error" onClick={handleDelete}>Excluir</Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default CrudTable;
